import { render, staticRenderFns } from "./_base-select.vue?vue&type=template&id=120f53f6&scoped=true&"
import script from "./_base-select.vue?vue&type=script&lang=js&"
export * from "./_base-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-select.vue?vue&type=style&index=0&id=120f53f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f53f6",
  null
  
)

export default component.exports